import React from "react";
import { usePortalAuth } from "../../lib/portal-auth-context";
import {
  DataTable,
  PageHeader,
  StatusPill,
  formatDate,
  useFetchList,
} from "./portal-ui";

export default function PortalShipments() {
  const { api } = usePortalAuth();
  const { items, loading } = useFetchList(api, "/shipments");

  return (
    <div data-testid="portal-shipments-page">
      <PageHeader
        eyebrow="Logística"
        title="Mis envíos"
        subtitle="Rastreo y estatus de cada envío asociado a tu cuenta."
      />
      <DataTable
        testId="portal-shipments-table"
        loading={loading}
        rows={items}
        emptyMsg="Sin envíos recientes."
        columns={[
          { key: "created_at", label: "Fecha", render: (r) => formatDate(r.created_at) },
          { key: "tracking", label: "Guía", render: (r) => r.tracking || "—" },
          { key: "carrier", label: "Paquetería", render: (r) => r.carrier || "—" },
          { key: "origin", label: "Origen", render: (r) => r.origin || "—" },
          {
            key: "cold_chain",
            label: "Cadena fría",
            render: (r) => (r.cold_chain ? "Sí" : "No"),
          },
          { key: "eta", label: "ETA", render: (r) => formatDate(r.eta) },
          { key: "status", label: "Estado", render: (r) => <StatusPill value={r.status} /> },
        ]}
      />
    </div>
  );
}
